import React, { Component } from 'react';
import { Panel } from 'component-lib';
import Vas from '../Vas';
import $ from 'jquery';
import '../css/Configuration.css';
import ConfigurationModel from '../models/Configuration';

import { ExtendedButton,SelectField,TextField } from "component-lib";

class Configuration  extends Component
{
    constructor(props){
       super(props);
       let configModel = new ConfigurationModel([this]);
       this.state =  configModel;
       this.state.Placeholder='';
       this.Save=function(){
           configModel.SaveConfiguration();
           window.location = "/configuration";
        };
    }

    componentDidMount(){
        $("#HeaderTitle").html(Vas.Resources.Menus["Configuration"]);
      
       let actual_JSON='';
        this.loadJSON(Vas.ApplicationUrl + '/config.json', function(response) {
            actual_JSON = JSON.parse(response);
            
            if (document.getElementById("APIURL")&&document.getElementById("APIkey")&&document.getElementById("AplicationURL")){
                document.getElementById("APIURL").value=actual_JSON.APIUrl;
                document.getElementById("APIkey").value=actual_JSON.APIKey;
                document.getElementById("AplicationURL").value=actual_JSON.ApplicationUrl;
            }
        });        
    }

    Update()
    {
        this.setState({});
    }

    handleChangeTheme = (event, index, value) => {
        this.setState({ value });
        //this.state.ThemeDisplay = value;
    };

    handleChangeLanguage = (value) => {
       
        switch (value){
            case '1':{
                break;
            }
            case 'en':{
                // eslint-disable-next-line
                this.state.LanguageDisplay = "Englisch";
                break;}
            case 'de':{
                // eslint-disable-next-line
                this.state.LanguageDisplay = "Deutsch";
                break;}
            default:break;
        }
    };

    loadJSON(file, callback) {   //https://laracasts.com/discuss/channels/general-discussion/load-json-file-from-javascript?page=0 28.06.2018

        let xobj = new XMLHttpRequest();
        xobj.overrideMimeType("application/json");
        xobj.open('GET', file, true); // Replace 'my_data' with the path to your file
        xobj.onreadystatechange = function () {
              if (xobj.readyState === 4 && xobj.status === "200") {
                // Required use of an anonymous callback as .open will NOT return a value but simply returns undefined in asynchronous mode
                callback(xobj.responseText);
              }
        };
        xobj.send(null);  
     }
      
    

   /* ApiSave(){

        let newPath=document.getElementById("API").value;
       
    }*/

    render() {

      // let languages = [];
      // let themes = [];

      /* if(this.state.Languages.length > 0)
       {
           languages = this.state.Languages.map(p => {
               return (
                   <MenuItem key={p} value={p} primaryText={p} />
               );
           });
       }*/

        let data = [];
        
        let ger = {};
        ger.Key = "de";
        ger.Display = Vas.Resources.Labels["German"];

        let eng = {};
        eng.Key = "en";
        eng.Display = Vas.Resources.Labels["English"];

        
        data.push(ger);
        data.push(eng);

        let role = localStorage.getItem("vas_role");

        let language='';
        let api='';

        language = (<Panel
          AppURL={Vas.ApplicationUrl}
          HeaderIcon={"Settings"}
          Header={Vas.Resources.Labels["Language"]}
          Width={200}
          Height={150}
          Float={"left"}
          Content={
            <div>
              <div><SelectField
                AppURL={Vas.ApplicationUrl}
                SelectFieldChooseText={Vas.Resources.Labels["PleaseChoose"]}
                Id={"sfLanguage"}
                Label={Vas.Resources.Labels["Language"]} 
                Data={data}
                OnChange={()=>{ this.handleChangeLanguage(document.getElementById("sfLanguage").value); }} /></div>
              <br />
              <div><ExtendedButton
                Usable={true}
                Text={Vas.Resources.Labels["Change"]}
                Float={"left"}
                Width={170}
                OnClick={()=>{this.Save();}} /></div>
            </div>
                    } />);

        if (role === "6"){
            api = (<Panel
              AppURL={Vas.ApplicationUrl}
              HeaderIcon={"Settings"}
              Header={Vas.Resources.Labels["API"]}
              Width={430}
              Height={240}
              Content={
                <div>
                  <div><TextField
                    AppURL={Vas.ApplicationUrl}
                    Width={400}
                    Id={"APIkey"}
                    Editable={false}
                    IsRequired={true}
                    Label={'APIKey'} /></div><br /><br />
                  <div><TextField
                    AppURL={Vas.ApplicationUrl}
                    Width={400}
                    Id={"APIURL"}
                    Editable={false}
                    IsRequired={true}
                    Label={'APIUrl'} /></div><br /><br />
                  <div><TextField
                    AppURL={Vas.ApplicationUrl}
                    Width={400}
                    Id={"AplicationURL"}
                    Editable={false}
                    IsRequired={true}
                    Label={'AplicationUrl'} /></div><br /><br /><br />
                </div>
                } />);
        }
       /*
       if(this.state.Themes.length > 0)
       {
           themes = this.state.Themes.map(p => {
               return (
                   <MenuItem key={ p } value={ p } primaryText={ p } />
               );
           });
       }

       return (
            <MuiThemeProvider muiTheme={Vas.Theme.getThemeDefinition()}>
            <div>
                <Paper className={ "configurationStyle" } zDepth={2} >
                        <SelectField name="language" floatingLabelText={ Vas.Resources.Labels["Language"] } fullWidth={true} onChange={ this.handleChangeLanguage }  value={this.state.LanguageDisplay} >
                        {languages}
                    </SelectField>
                    <SelectField name="theme" floatingLabelText={ Vas.Resources.Labels["ThemeSelection"] } fullWidth={true} onChange={ this.handleChangeTheme } value={this.state.ThemeDisplay} >
                        {themes}
                    </SelectField>
                    <RaisedButton name='doButton' className='loginButton'  label={ Vas.Resources.Labels["Use"] } onClick={ ()=> { this.Save()}}/>
                </Paper>
            </div>
            </MuiThemeProvider>
        )*/

       return (<div >
         {language}
         {api}
          
       </div>);
    }
}
export default Configuration;
